module.exports = __webpack_public_path__ + "c410fc6d1c213df074e378581d46048f.svg";